var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 1.02344V10.0234C10.75 10.4219 10.3984 10.7734 10 10.7734C9.57812 10.7734 9.25 10.4219 9.25 10.0234V3.48438L6.10938 8.17188C5.82812 8.59375 5.14844 8.59375 4.86719 8.17188L1.75 3.48438V10C1.75 10.4219 1.39844 10.75 1 10.75C0.578125 10.75 0.25 10.4219 0.25 10V1C0.25 0.671875 0.460938 0.390625 0.765625 0.296875C1.09375 0.203125 1.42188 0.320312 1.60938 0.601562L5.5 6.41406L9.36719 0.601562C9.55469 0.320312 9.88281 0.203125 10.2109 0.296875C10.5156 0.390625 10.75 0.671875 10.75 1.02344Z",
    fill: "#FF940A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.ebef8e77ae1d29c93ab2105ed73a2d34.svg";
export { ForwardRef as ReactComponent };